import { useState } from "react"
import { ChevronDown } from "lucide-react"

// Redaktionell noch in Abstimmung (Stand 22.09.2026) - Texte sind bewusst hier
// gebuendelt, damit sie ohne Umbau der Komponente ausgetauscht werden koennen.
const FAQ: [string, string][] = [
  [
    "Wie erhalte ich meinen Zugang nach dem Kauf?",
    "Nach erfolgreicher Zahlung wird Ihr Konto automatisch angelegt und freigeschaltet. Sie erhalten die Zugangsdaten und eine kurze Onboarding-Anleitung per E-Mail – in der Regel innerhalb weniger Minuten.",
  ],
  [
    "Kann ich auf Rechnung bestellen?",
    "Ja. Wählen Sie im Warenkorb „Auf Rechnung“ und geben Sie Ihre Rechnungsdaten an. Wir prüfen die Anfrage und senden die Rechnung (zahlbar in 14 Tagen). Der Zugang wird nach dem Rechnungsversand freigeschaltet.",
  ],
  [
    "Verlängert sich die Lizenz automatisch?",
    "Nein. Die Navigator-Lizenzen haben eine feste Laufzeit (3 oder 12 Monate) und sind kein Abo. Es gibt keinen automatischen Nachkauf und keine versteckten Zusatzkosten. Auch die Fair-Use-Grenze von 2 Mio. Token pro Monat löst keine automatische Abrechnung aus.",
  ],
  [
    "Was ist der Unterschied zwischen Navigator, Infopaketen und Bundle?",
    "Der Navigator ist der dialogbasierte KI-Zugang zu den Milieu-Daten mit fester Laufzeit. Infopakete sind PDF-Pakete mit dauerhaftem Zugang über das SINUS Infoportal. Das Premium-Bundle kombiniert die Navigator-Jahreslizenz mit zwei frei wählbaren Infopaketen, einem Beratungsgespräch und dem Premium-Status.",
  ],
  [
    "Lohnt sich der Mehrfachbezug von Infopaketen?",
    "Ab zwei Paketen greifen die Staffelpreise – die Ersparnis steigt mit der Anzahl. Ab drei Paketen ist zusätzlich der Premium-Status enthalten.",
  ],
  [
    "Was bedeutet der Premium-Status?",
    "Ab einem Auftragswert von 4.150 Euro innerhalb der letzten zwei Kalenderjahre erhalten Sie den Premium-Status im SINUS Infoportal: vergünstigter Navigator-Zugang, ein Online-Beratungsgespräch, exklusive Booklets zu Sonderthemen sowie Webinar-Aufzeichnungen und Handouts.",
  ],
]

const CONTACT_EMAIL = "infopakete@sinus-institut.de"

export function Faq() {
  const [open, setOpen] = useState<number | null>(2)

  return (
    <div className="grid items-start gap-10 md:grid-cols-[420px_1fr] md:gap-16">
      <div>
        <h2 className="text-xl font-medium text-brand-accent md:text-3xl">FAQ</h2>
        <p className="mt-3 text-xs text-brand-muted md:text-sm">
          Hier finden Sie Antworten auf die wichtigsten Fragen rund um Freischaltung, Bestellung,
          Nutzung und Umsatzsteuer.
        </p>
        <div className="mt-7 rounded-card border border-line bg-white p-5 md:p-6">
          <h3 className="text-base font-medium md:text-lg">Sie haben noch Fragen?</h3>
          <p className="mt-2 text-xs text-brand-muted md:text-sm">
            Unser Team hilft Ihnen gerne weiter. Schreiben Sie uns einfach, wenn Sie weitere Fragen
            haben.
          </p>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            className="mt-4 inline-flex rounded-field border border-brand-blue px-6 py-2.5 text-sm font-medium text-brand-blue transition hover:bg-brand-tint"
          >
            Kontakt aufnehmen
          </a>
        </div>
      </div>

      <div>
        {FAQ.map(([q, a], i) => (
          <div key={q} className="border-b border-line">
            <button
              onClick={() => setOpen(open === i ? null : i)}
              aria-expanded={open === i}
              className="flex w-full items-center justify-between gap-4 py-4 text-left text-sm md:py-5 md:text-base"
            >
              <span>{q}</span>
              <ChevronDown
                className={`h-[18px] w-[18px] shrink-0 text-brand-muted transition-transform ${
                  open === i ? "rotate-180" : ""
                }`}
              />
            </button>
            {open === i && (
              <p className="max-w-[660px] pb-5 text-xs text-brand-muted md:text-sm">{a}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
